// extracted by mini-css-extract-plugin
export default {"container":"suspense-fallback__container___QmP0q"};